import List from './List';
import mapProduct from './mapProduct';

export interface RawList {
	finalCalculation: {
		readonly referenceBasketVersion: string;
	};
	reference: {
		readonly packageSize: number;
		readonly dosageStrength: number;
		readonly usualTherapeuticDailyDose: number;
		readonly usualTherapeuticDailyDosePerPackage: number;
	};
	products: any[];
	_links: { [key: string]: string };
}

export default function mapList(list: RawList): List {
	return new List(list.products.map(mapProduct), list.finalCalculation, list.reference, list._links);
}
